import { SupervisionModeEnum } from '@/types/generated/graphql';
import { create } from 'zustand';
import { LiveTranscriptSession } from '../live-call.types';

export type LiveCallStatesStore = {
  supervisingCallId: number | null;
  supervisionMode: SupervisionModeEnum | null;
  isDrawerOpen: boolean;
  transcriptSession: LiveTranscriptSession | null;
  isTranscriptCollapsed: boolean;
  setSupervisingCallId: (supervisionId: number | null) => void;
  setSupervisionMode: (supervisionMode: SupervisionModeEnum | null) => void;
  openDrawer: VoidFunction;
  closeDrawer: VoidFunction;
  startTranscriptSession: (session: LiveTranscriptSession) => void;
  stopTranscriptSession: VoidFunction;
  toggleTranscriptCollapsed: VoidFunction;
  resetStates: () => void;
};

export const useLiveCallStatesStore = create<LiveCallStatesStore>((set) => ({
  supervisingCallId: null,
  supervisionMode: null,
  isDrawerOpen: false,
  transcriptSession: null,
  isTranscriptCollapsed: false,
  setSupervisingCallId: (supervisionId) => set({ supervisingCallId: supervisionId }),
  setSupervisionMode: (supervisionMode) => set({ supervisionMode }),
  openDrawer: () => set({ isDrawerOpen: true }),
  closeDrawer: () => set({ isDrawerOpen: false }),
  startTranscriptSession: (session) => set({ transcriptSession: session, isTranscriptCollapsed: false }),
  stopTranscriptSession: () => set({ transcriptSession: null, isTranscriptCollapsed: false }),
  toggleTranscriptCollapsed: () => set((state) => ({ isTranscriptCollapsed: !state.isTranscriptCollapsed })),
  resetStates: () =>
    set({
      supervisingCallId: null,
      supervisionMode: null,
      transcriptSession: null,
      isTranscriptCollapsed: false,
    }),
}));
